<div class="sh-facet-list">
    <sh-facet
        *ngFor="let facet of facets"
        [facet]="facet"
        [showMoreMsg]="showMoreMsg"
        [blockShowMore]="blockShowMore"
        (loadMore)="onLoadMore($event)"
        (valueSelected)="onValueSelected($event)"
        (selectionChanged)="onSelectionChange($event)"
    ></sh-facet>
</div>
